/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LngInputs */

const en__field_lng = /** @type {(inputs: _Field_LngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitude`)
};

/**
* | output |
* | --- |
* | "Longitude" |
*
* @param {_Field_LngInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_lng = /** @type {((inputs?: _Field_LngInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LngInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_lng(inputs)
});